// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // serverUrl: 'https://factura.parquelacolina.com/api',
  // serverUrl: 'https://bills.demo.mallgo.co/api',
  // serverUrl: 'https://api.demo.mallgo.co',
  serverUrl: 'https://api.staging.mallgo.co',
  // serverUrl: 'http://localhost:8000/api',
  billsServiceUrl: 'https://28hdzl3gga.execute-api.us-east-2.amazonaws.com/process',
  modelExecutorUrl: 'https://api.ai.inkremental.co/model-executor/requests',
  modelExecutorApiKey: 'uac_IM70fI57f4qLxxIw-IVsIb4VGqv3LPt0T17TQFj7fwY',
  recaptcha: {
    siteKey: ''
  },
  adminUrl: 'https://administrador.staging.mallgo.co',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
